import React from 'react';
import { useField } from 'formik';

import styles from './RadioBtnInput.module.scss';

const { 'radio-input': radioInputClass } = styles;

const RadioBtnInput = ({ title, fieldName, value, isChecked, ...props }) => {
  // form helpers
  const [field, , helpers] = useField(fieldName);
  const { setValue } = helpers;

  return (
    <div className={radioInputClass} onClick={() => setValue(value)}>
      <label htmlFor={title}>
        <input {...field} {...props} type="radio" name={title} value={value} checked={isChecked} />
        <p>{title}</p>
      </label>
    </div>
  );
};

export default RadioBtnInput;
